/**
 * Newsletter registration form, that appears in the footer
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { addToNewsletter } from '../api';
import { focusAndScroll, isMobile } from "../utils";
var $ = window.jQuery;
var HomepageForm = /** @class */ (function (_super) {
    __extends(HomepageForm, _super);
    function HomepageForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.email = '';
        _this.sent = false;
        _this.error = false;
        _this.isOpen = false;
        _this.isLoading = false;
        return _this;
    }
    HomepageForm.prototype.watchIsSearchOpen = function (isOpen) {
        if (isOpen && isMobile())
            focusAndScroll(this.$refs.input, $('.header'));
        $('body').toggleClass('is-newsletter-open', isOpen);
    };
    HomepageForm.prototype.submit = function () {
        var _this = this;
        this.isLoading = true;
        addToNewsletter(this.email).then(function (data) {
            _this.isLoading = false;
            if (data) {
                _this.sent = true;
                _this.error = 'error' in data;
            }
        });
        // Close the form on escape
        $(document).on('keyup', function (e) {
            if (e.key === 'Escape') {
                _this.isOpen = false;
            }
        });
    };
    __decorate([
        Prop({ default: 'Enter Email' })
    ], HomepageForm.prototype, "emailLabel", void 0);
    __decorate([
        Prop({ default: 'Submit' })
    ], HomepageForm.prototype, "buttonLabel", void 0);
    __decorate([
        Prop({ default: 'Sign up to our Newsletter:' })
    ], HomepageForm.prototype, "title", void 0);
    __decorate([
        Prop({ default: "You've successfully registered to our newsletter, thanks!" })
    ], HomepageForm.prototype, "successMessage", void 0);
    __decorate([
        Prop({ default: "Can't register this mail. Have you already registered before?" })
    ], HomepageForm.prototype, "errorMessage", void 0);
    __decorate([
        Watch('isOpen')
    ], HomepageForm.prototype, "watchIsSearchOpen", null);
    HomepageForm = __decorate([
        Component
    ], HomepageForm);
    return HomepageForm;
}(Vue));
export default HomepageForm;
